import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import CoursesPage from "../pages/courses/page";
import BookingPage from "../pages/booking/page";
import AboutPage from "../pages/about/page";
import ReviewsPage from "../pages/reviews/page";
import ContactPage from "../pages/contact/page";
import FaqPage from "../pages/faq/page";
import GroupTrainingPage from "../pages/group-training/page";
import ReferralPage from "../pages/referral/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/courses", element: <CoursesPage /> },
  { path: "/booking", element: <BookingPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/reviews", element: <ReviewsPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/faq", element: <FaqPage /> },
  { path: "/group-training", element: <GroupTrainingPage /> },
  { path: "/referral", element: <ReferralPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
